import PhotoGalleryTabContent from '@/components/community/tabs/PhotoGallery.vue';
import { mountCommunityComponentAsApp } from '@/entrypoints/helpers/community-mounter';
import { mountProductTab } from '@/entrypoints/helpers/tab-mounter';

const mountSelector = '.product-tab-photo-gallery-container';
const boundTabSelector = '#tab-user-gallery';

mountProductTab(
  PhotoGalleryTabContent,
  mountSelector,
  boundTabSelector,
  mountCommunityComponentAsApp
);
